module.exports = __webpack_public_path__ + "static/media/stofferingen-01.9239f34f.jpg";